import React, {  useEffect } from 'react';

//Components
import TabelaListagemFichas from '../../../../components/TabelaListagemFichas/TabelaListagemFichas';

//Helpers
import mascaras from '../../../../helpers/mascaras';


export default function TabelaInscricoesMunicipais({ inscricoesMunicipais = [], paging = true }) {

    useEffect(() => {
        inscricoesMunicipais?.map(value => {
            value.cnpj = mascaras.cnpjMask(value.cnpj);
            return value;
        });
    }, []);

    //Cabeçalhos da tabela de endereços
    const headersTabelaInscricoesMunicipais = [
        { value: "CNPJ", objectValue: "cnpj", align: "left" },
        { value: "Inscrição municipal", objectValue: "inscricaoMunicipal", align: "left" },
        { value: "Razão Social", objectValue: "razaoSocial", align: "left" }
    ];

    return <TabelaListagemFichas headers={headersTabelaInscricoesMunicipais} items={inscricoesMunicipais} paging={paging} />
}